/**
 * Init staggered fade-in animation for statistics
 */
function initStatisticsAnimation( node, gsap ) {
	const statistics = node.querySelectorAll( '.statistic' );

	if ( ! statistics || statistics.length === 0 ) {
		return;
	}

	gsap.set( statistics, {
		opacity: 0,
		y: '10%',
	} );

	gsap.to( statistics, {
		opacity: 1,
		y: 0,
		duration: 0.6,
		ease: 'power4.out',
		stagger: 0.15,
		scrollTrigger: {
			trigger: node,
			start: 'top 60%',
			toggleActions: 'play none none none',
		},
	} );
}

/**
 * Init function
 */
function init( node ) {
	if ( ! ( node instanceof HTMLElement ) ) {
		return;
	}

	// Validate GSAP availability
	const { gsap } = window;
	if ( ! gsap ) {
		console.warn( 'GSAP not available. Make sure gsap and gsap-scroll-trigger are enqueued.' );
		return;
	}

	// ScrollTrigger registers itself with GSAP when loaded
	const ScrollTrigger = gsap.ScrollTrigger || window.ScrollTrigger;
	if ( ! ScrollTrigger ) {
		console.warn( 'ScrollTrigger not available. Make sure gsap-scroll-trigger is enqueued after gsap.' );
		return;
	}

	initStatisticsAnimation( node, gsap );
}

/**
 * Initialize statistics blocks when DOM is ready
 * Deferred scripts execute after DOMContentLoaded
 */
const initStatistics = () => {
	document.querySelectorAll( '.statistics' ).forEach( init );
};

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initStatistics );
} else {
	initStatistics();
}
